import useAuth from "@/contexts/auth/auth-context";
import { EmailModal } from "./profile-settings/email-modal";
import { PasswordModal } from "./profile-settings/password-modal";
import { DisplayNameModal } from "./profile-settings/display-name-modal";

export const ProfileSettingsForm = () => {
  const { user } = useAuth();

  return (
    <div className="px-7 py-5 w-full space-y-8">
      <div>
        <h2 className="text-xl font-bold text-white">Profile Information</h2>
        <p className="text-sm text-musio-text-light">Update Your Account Details</p>
      </div>

      <div className="flex flex-col space-y-5">
        <div className="flex flex-col space-y-1">
          <p className="text-sm text-musio-text-light">Email</p>
          <div className="flex flex-row items-center justify-between">
            <p className="truncate text-musio-light-lilac max-w-xs">
              {user?.email}
            </p>
            <EmailModal />
          </div>
        </div>
        <div className="flex flex-col space-y-1">
          <p className="text-sm text-musio-text-light">Password</p>
          <div className="flex flex-row items-center justify-between">
            <p className="truncate text-musio-light-lilac max-w-xs">
              **********
            </p>
            <PasswordModal />
          </div>
        </div>
        <div className="flex flex-col space-y-1">
          <p className="text-sm text-musio-text-light">Display Name</p>
          <div className="flex flex-row items-center justify-between">
            <p className="truncate text-musio-light-lilac max-w-xs">
              {user?.contactName}
            </p>
            <DisplayNameModal />
          </div>
        </div>
      </div>
    </div>
  );
};
